import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {

  url = environment.url;
  constructor(public http: HttpClient) { }

  getAllEmployees() {
    return this.http.get(`${this.url}` + '/employee/getEmployeesWithoutOutSource').pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting  employees'))),
    );
  }

  getOutsourceEmployees() {
    return this.http.get(`${this.url}` + '/employee/getOutsourceEmployees').pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting outsource employees'))),
    );
  }

  getUsers() {
    return this.http.get(`${this.url}` + '/employee/getSAEmployees').pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting  employees'))),
    );
  }

  getEmployeeById(emp_id) {
    // console.log(emp_id)
    return this.http.get(`${this.url}` + '/employee/getEmployee/' + emp_id).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in gettinhg employee'))),
    );
  }

  getEmployeesByStationId(stations) {
    let stationids = [];
    stations.forEach(element => {
      //console.log(element)
      stationids.push(element.id)
    });
    //console.log(stationids)
    return this.http.post(`${this.url}` + '/employee/getAgentsOnStationId', stationids).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in saving employee'))),
    );
  }

  saveEmployee(employeeData) {
    return this.http.post(`${this.url}` + '/employee/register', employeeData).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in saving employee'))),
    );
  }

  updateEmployee(employeeData) {
    return this.http.put(`${this.url}` + '/employee/update', employeeData).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in Update employee'))),
    );
  }

  getEmployeeProfile(id) {
    return this.http.get(`${this.url}` + '/employee/getEmployee/' + id).pipe(tap(res =>res),
      catchError(err => throwError(new Error('Issue in get employee profile'))),
    );
  }

  getSuperAdminDetails(id){
    return this.http.get(`${this.url}` + '/employee/getSuperAdmin/' + id).pipe(tap(res => res),
    catchError(err => throwError(new Error('Issue in get super admin details'))),
  );
  }

  addAdminProfile(employeeData) {
    return this.http.post(`${this.url}` + '/employee/insertsuperadmin', employeeData).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in saving employee'))),
    );
  }

  updateAdminProfile(employeeData) {
    return this.http.put(`${this.url}` + '/employee/updateEmpStatus', employeeData).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in Update employee'))),
    );
  }

 
}
